import script from "./AuthLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLogin.vue?vue&type=script&setup=true&lang=js"

import "./AuthLogin.vue?vue&type=style&index=0&id=0ca26213&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alvar\\OneDrive\\Kaggle\\Vue\\pro_vouchers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca26213"]])

export default __exports__